var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 17,
  viewBox: "0 0 24 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.4 8.714H23M8.6 1.43 1.4 8.713 8.6 16",
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgPrev as ReactComponent };
export default __webpack_public_path__ + "assets/media/prev.df0fcf9a58f31af78bdcc4d5f384c797.svg";